import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import config from '../../../meta/config';

const SEO = ({ title, description, cover, slug, section, canonical, cloudinary }) => {
  const postURL =
    slug && section ? `${config.siteUrl}/${section}/${slug}` : config.siteUrl;
  const realPrefix = config.pathPrefix === '/' ? '' : config.pathPrefix;
  const image = cloudinary ? cover : config.siteUrl + realPrefix + cover;
  const blogURL = config.siteUrl + config.pathPrefix;

  const canonicalUrl = canonical || `${postURL}/`;

  const schemaOrgJSONLD = [
    {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: blogURL,
      name: title,
      alternateName: config.siteTitleAlt ? config.siteTitleAlt : '',
    },
    [
      {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            item: {
              '@id': postURL,
              name: title,
              image,
            },
          },
        ],
      },
      {
        '@context': 'http://schema.org',
        '@type': 'BlogPosting',
        url: blogURL,
        name: title,
        alternateName: config.siteTitleAlt ? config.siteTitleAlt : '',
        headline: title,
        image: {
          '@type': 'ImageObject',
          url: image,
        },
        description,
      },
    ],
  ];

  return (
    <Helmet titleTemplate="%s | Boldare" defaultTitle="Boldare">
      {/* General tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="image" content={image} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Schema.org tags */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script>

      {/* OpenGraph tags */}
      <meta property="og:url" content={postURL} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta
        property="fb:app_id"
        content={config.siteFBAppID ? config.siteFBAppID : ''}
      />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:creator"
        content={config.userTwitter ? config.userTwitter : ''}
      />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

SEO.defaultProps = {
  title: config.siteTitle,
  description: config.siteDescription,
  cover: config.siteCover,
  canonical: '',
  slug: '',
  section: '',
  cloudinary: false,
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  canonical: PropTypes.string,
  cover: PropTypes.string,
  slug: PropTypes.string,
  section: PropTypes.string,
  cloudinary: PropTypes.bool,
};

export default SEO;
